export enum ESuburbanFloors {
  One = 'one',
  TwoAndMore = 'twoAndMore',
}
